import * as Yup from "yup";

const TRANSLATION_BASE_PATH = "_SELECT_ORGANIZATION._CHOOSE_AS_STUDENT._JOIN_CLASSROOM";

export const formValidator = (translate: (key: string) => string) =>
	Yup.object({
		virtualClassCode: Yup.string().nullable().required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
	});
